window.addEventListener('load', () => {
  if (document.getElementById('js-nav-open')) {
    document.getElementById('js-nav-open').addEventListener('click', () => {
      document.querySelector('body').classList.add('is-showNav');
    });
    document.getElementById('js-nav-close').addEventListener('click', () => {
      document.querySelector('body').classList.remove('is-showNav');
    });
  }
});